import { IdMeVerificationScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <IdMeVerificationScreen />;
}
